import Rules from '@mcfe/tools-rules';

export const ciqInfoDtoListDefault = [
    {
        ciqPicUrlList: [],
        ciqNo: '',
        skuIdList: [],
    },
];

const isProd = ['staging', 'production'].includes(process.env.NODE_ENV);

export const mtobClientUrl = `https://portal-portm.meituan.com/klfe/mtob/${isProd ? 'prod' : 'test'}/downloadConfig?version=2.1.4`;

export const defaultFunc = () => {};

// 已切换为后端下发，暂时不使用
export const certTypeMapList = [
    {
        certType: 1,
        certTypeName: '入境货物检验检疫证明（简称CIQ）',
        certInfo: [],
    },
    {
        certType: 2,
        certTypeName: '报关单',
        certInfo: [],
    },
    {
        certType: 3,
        certTypeName: '农残/药残',
        certInfo: [],
    },
    {
        certType: 4,
        certTypeName: '核酸检测报告',
        certInfo: [],
    },
    {
        certType: 5,
        certTypeName: '消毒证明',
        certInfo: [],
    },
    {
        certType: 6,
        certTypeName: '出厂检验报告',
        certInfo: [],
    },
    {
        certType: 7,
        certTypeName: '动物检疫合格证明',
        certInfo: [],
    },
    {
        certType: 99,
        certTypeName: '其他合格证明',
        certInfo: [],
    },
];


export const EPrinterStatus = {
    NORMAL: {
        key: 'NORMAL',
        value: '正常',
    }, //  正常
    ERROR: {
        key: 'ERROR',
        value: '错误',
    }, //  正常
    OFFLINE: {
        key: 'OFFLINE',
        value: '脱机（仅驱动打印机会返回）',
    }, //  正常
    SUSPENDED: {
        key: 'SUSPENDED',
        value: '暂停（仅驱动打印机会返回）',
    }, //  正常
    OPEN_LID: {
        key: 'OPEN_LID',
        value: '开盖（仅免驱打印机会返回）',
    }, //  正常
    SHORT_PAPER: {
        key: 'SHORT_PAPER',
        value: ' 缺纸（仅免驱打印机会返回）',
    }, //  正常
    SHORT_PAPER_OPEN_LID: {
        key: 'SHORT_PAPER_OPEN_LID',
        value: '缺纸&开盖（仅免驱打印机会返回）',
    }, //  正常
};

/**
 * PCS_CODE（件码）、BULK_WEIGHT_CODE(24散称码)、FRESH_PIECE_CODE(27生鲜码)、NORMAL_CODE(69标准码)、DATE_CODE(26日期码)、UNKNOWN_CODE(未知码类型)
 */
export const CODE_TYPE = {
    PCS_CODE: 'PCS_CODE',
    BULK_WEIGHT_CODE: 'BULK_WEIGHT_CODE',
    FRESH_PIECE_CODE: 'FRESH_PIECE_CODE',
    NORMAL_CODE: 'NORMAL_CODE',
    DATE_CODE: 'DATE_CODE',
    UNKNOWN_CODE: 'UNKNOWN_CODE',
};

/**
   getTimezoneOffset：时区偏差（time-zone offset）表示协调世界时（UTC）与本地时区之间的差值，单位为分钟。需要注意的是如果本地时区后于协调世界时，则该差值为正值，如果先于协调世界时则为负值。例如你所在时区为 UTC+10（澳大利亚东部标准时间），将会返回 -600。对于同一个时区，夏令时（Daylight Saving Time）将会改变这个值
*/
// 将当前日期转换为东八区的日期时间戳
export function localTimestampToUTC8Timestamp(localTimestamp) {
    const localTime = new Date(localTimestamp);
    const localOffset = localTime.getTimezoneOffset() * 60000; // 本地时区偏移量（以毫秒为单位）
    const east8Offset = 8 * 60 * 60000; // 东八区时区偏移量（以毫秒为单位）
    const east8Time = localTimestamp - localOffset - east8Offset;
    return east8Time;
}

// 将东八区的日期转换为当前系统时间的日期时间戳
export function UTC8TimestampToLocalTimestamp(east8Timestamp) {
    const localDate = new Date();
    const localOffset = localDate.getTimezoneOffset() * 60000; // 本地时区偏移量（以毫秒为单位）
    const east8Offset = 8 * 60 * 60000; // 东八区时区偏移量（以毫秒为单位）
    const localTime = east8Timestamp + east8Offset + localOffset;
    return localTime;
}


export const preCheckTableColumns = [
    {
        type: 'index',
        label: '序号',
    },
    {
        label: 'SKUID',
        prop: 'skuId',
    },
    {
        label: '商品名称',
        prop: 'spuName',
    },
    {
        label: '前置质检批市',
        prop: 'preQualityCheckMarket',
    },
];
// 时间维度按钮切换
export const TIME_MODE_BTN_MAP = {
    1: '切为小时模式',
    2: '切为整天模式',
};

// 生成小时映射的函数
export function generateHourMap() {
    const hourMap = {};
    for (let i = 0; i < 24; i++) {
        const hour = i.toString().padStart(2, '0');
        hourMap[i] = {
            label: `${hour}:00`,
            value: `${hour}:00:00`,
        };
    }
    return hourMap;
}

// 使用函数生成小时映射
export const HOUR_MAP = generateHourMap();

export const HOUR_LIST = Object.values(HOUR_MAP);

// 效期类型 -1 未知效期类型, 1 天维度，2 小时维度
export const OTHER_TYPE = -1;
export const DAY_TYPE = 1;
export const HOUR_TYPE = 2;

// 是否云仓
export const YC_FLAG_MAP = {
    1: '否',
    2: '是',
};
export const countryRules = [
    Rules.isRequired('请输入'),
    Rules.lenRange({ max: 30 }, '最多输入30个字'),
];
